import AWS from 'aws-sdk'

import Config from 'src/config/app'

AWS.config.update({
  region: Config.services.aws.region,
  accessKeyId: Config.services.aws.accessKeyId,
  secretAccessKey: Config.services.aws.secretAccessKey,
})

const S3 = new AWS.S3()

const awsStorage = async (
  bucket: string,
  path: string,
  file: File,
  onProgress: any,
  onError: any,
  onSuccess: any
): Promise<any> => {
  const params = {
    Bucket: bucket,
    Key: path,
    Body: file,
    ContentType: file.type,
    ACL: 'public-read',
  }

  return new Promise((resolve, reject) => {
    S3.putObject(params, (err, result) => {
      if (err) {
        reject(err)
        onError()
      }
      if (result) {
        resolve(result)
        onSuccess(file)
      }
    }).on('httpUploadProgress', ({ loaded, total }) => {
      const percent = Math.round((loaded / total) * 100)
      onProgress({ percent }, file)
    })
  })
}

export { awsStorage }
